import React, { Component } from "react";
import { Link } from "react-router-dom";

import HeaderSubPart from "./HeaderSubPart";
import { GlobalAuthContext } from "../../context/AuthProvider";

let libertatelogo = require("../../images/libertate.png");
let insurecomplogo = require("../../images/new-logo.png");
let altMarketLogo = require("../../images/alt_market_logo.png");

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoSize: "large",
      loggedInPeo: undefined,
    };
  }

  static contextType = GlobalAuthContext;

  componentDidMount = async () => {
    const { user } = this.context;
    try {
      let sessionData = user;
      if (sessionData) {
        let userType = sessionData.attributes["custom:user_type"];
        if (userType === "peo") {
          let email = sessionData.attributes.email;
          let user_peo = email.split("@")[0];
          this.setState({ loggedInPeo: user_peo });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    let isMobile = window.innerWidth < 900;
    let { logoSize, loggedInPeo } = this.state;
    let isLoggedIn = sessionStorage?.getItem("isLoggedIn");
    //Sharina asked to comment the libertate logo in dev libertate
    //Sharina asked to revert back the libertate logo in JUNSEP2024-770

    return (
      <>
        <nav
          id="navbarMain"
          className="new-navbar container-fluid nav_fontsize"
          style={{
            backgroundColor: "white",
            height: "auto",
            fontSize: "16px",
            padding: "20px 0px",
          }}
        >
          <div className="row justify-content-between align-items-center w-100 no-gutters">
            {process.env.REACT_APP_MODE !== "beta" ? (
              <Link
                to={"/"}
                className="col-3 col-md-3 col-sm-3 col-lg-3 navbar-brand  flex-column align-items-start navlisting "
              >
                {/* <img
                  className="imagesizelogo"
                  id="imagesizelogo"
                  style={
                    logoSize === "large"
                      ? { height: "100px", marginLeft: "2rem" }
                      : { height: "100px", marginLeft: "1.6rem" }
                  }
                  src={loggedInPeo === "ies" ? altMarketLogo : libertatelogo}
                  alt="libertate logo"
                /> */}
              </Link>
            ) : (
              <div></div>
            )}

            <div className="d-none d-md-flex col-6 col-sm-0 col-lg-6 justify-content-center align-items-center">
              {isMobile ? " " : <HeaderSubPart />}
            </div>

            <Link
              to={"/"}
              className="col-3 col-md-3 col-sm-9 col-lg-3 navbar-brand d-flex align-items-end justify-content-end"
              style={{ flexDirection: "column" }}
              onClick={(e) => {
                e.preventDefault();
                const protocol = window.location.protocol;
                const targetHost = "www.insurecomp.com";
                const targetUrl = `${protocol}//${targetHost}`;
                window.open(targetUrl, "_blank");
                console.log("Redirecting to beta.insurecomp.com", targetUrl);
              }}
            >
              <img
                className="imagesizelogoicomp"
                id="imagesizelogoicomp"
                style={
                  logoSize === "large"
                    ? {
                        height: "70px",
                      }
                    : {
                        height: "71px",
                      }
                }
                src={insurecomplogo}
                alt="insurecomp logo"
              />
            </Link>
          </div>
        </nav>
      </>
    );
  }
}

export default Header;
